import React from 'react'
import { Button } from '@/components/ui/button'
import { ResolveFormSubmitValues } from 'api/WorldCheck/Types/ResolveFormSubmitValues'
import { Box } from 'components/Box'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'

import { FormFieldContainer, Wrapper } from '../Client.styles'

const WorldCheckResolveFormUI: React.FC<FormikProps<Resolve> & OuterProps> = (props) => {
  const {
    handleSubmit,
    setSubmitting,
    values,
    isSubmitting,
    setFieldValue,
    setValues,
    errors,
    showInformedComplianceModal,
  } = props

  const submitForm = () => {
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <Wrapper>
      <Form onSubmit={submitForm}>
        <FormFieldContainer>
          <div>
            <label>
              Status<span>*</span>
            </label>
            <Field
              component='select'
              name='statusId'
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                const statusId = Number.parseInt(e.target.value, 10)
                if (statusId === 1) {
                  setValues({ statusId, riskId: undefined, remark: '', reasonId: undefined })
                } else if (statusId === 2) {
                  setValues({ statusId, riskId: undefined, remark: '', reasonId: undefined })
                } else if (statusId === 3) {
                  setValues({ statusId, riskId: 4, remark: '', reasonId: 3 })
                } else {
                  setValues({ statusId, riskId: 4, remark: '', reasonId: 4 })
                }
              }}
            >
              <option key={1} value={1}>
                Positive
              </option>
              <option key={2} value={2}>
                Possible
              </option>
              <option key={3} value={3}>
                False
              </option>
              <option key={4} value={4}>
                Unspecified
              </option>
            </Field>
          </div>
          {errors.statusId && <div className='is-danger'>{errors.statusId}</div>}
        </FormFieldContainer>
        <FormFieldContainer>
          <div>
            <label>
              Risk Level<span>*</span>
            </label>
            <Field
              component='select'
              name='riskId'
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                setFieldValue('riskId', Number.parseInt(e.target.value, 10))
              }
            >
              <option key={0} value={undefined}>
                Not Set
              </option>
              <option key={4} value={4} disabled={values.statusId === 1}>
                Unknown
              </option>
              <option key={1} value={1} disabled={values.statusId === 3 || values.statusId === 4}>
                Low
              </option>
              <option key={2} value={2} disabled={values.statusId === 3 || values.statusId === 4}>
                Medium
              </option>
              <option key={3} value={3} disabled={values.statusId === 3 || values.statusId === 4}>
                High
              </option>
            </Field>
          </div>
          {errors.riskId && <div className='is-danger'>{errors.riskId}</div>}
        </FormFieldContainer>
        <FormFieldContainer>
          <div>
            <label>
              Reason<span>*</span>
            </label>
            <Field
              component='select'
              name='reasonId'
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                setFieldValue('reasonId', Number.parseInt(e.target.value, 10))
              }
            >
              <option key={0} value={undefined}>
                Not Set
              </option>
              <option key={1} value={1} disabled={values.statusId !== 1}>
                Full match
              </option>
              <option key={2} value={2} disabled={values.statusId !== 2}>
                Partial match
              </option>
              <option key={3} value={3} disabled={values.statusId !== 3}>
                No match
              </option>
              <option key={4} value={4} disabled={values.statusId !== 4}>
                Unknown
              </option>
            </Field>
          </div>
          {errors.reasonId && <div className='is-danger'>{errors.reasonId}</div>}
        </FormFieldContainer>
        <FormFieldContainer>
          <div>
            <label>Reason</label>
            <Field as='textarea' type='text' name='remark' rows='3' maxLength='130' />
          </div>
        </FormFieldContainer>
        <Box display='flex' flexDirection='row' style={{ float: 'right' }}>
          <Button disabled={isSubmitting} type='button' onClick={submitForm}>
            Resolve
          </Button>
          <Button type='button' onClick={showInformedComplianceModal}>
            Inform Compliance
          </Button>
        </Box>
      </Form>
    </Wrapper>
  )
}

interface Resolve {
  statusId: number
  riskId?: number
  reasonId?: number
  remark: string
}

interface OuterProps {
  screeningId?: string

  showInformedComplianceModal(): void
  onSubmit(values: ResolveFormSubmitValues): Promise<void>
}

export const WorldCheckResolveForm = withFormik<OuterProps, Resolve>({
  mapPropsToValues: () => {
    return {
      statusId: 1,
      remark: '',
      reasonId: undefined,
      riskId: undefined,
    }
  },
  handleSubmit: async (values, { props, setSubmitting, resetForm }) => {
    try {
      if (props.screeningId && values.reasonId && values.riskId) {
        await props.onSubmit({
          id: props.screeningId,
          reasonId: values.reasonId,
          remark: values.remark,
          riskId: values.riskId,
          records: [],
          statusId: values.statusId,
        })
      }
    } finally {
      setSubmitting(false)
      resetForm()
    }
  },
  validate: (values) => {
    const errors: FormikErrors<Resolve> = {}
    if (!values.statusId) {
      errors.statusId = 'required'
    }
    if (!values.riskId) {
      errors.riskId = 'required'
    }
    if (!values.reasonId) {
      errors.reasonId = 'required'
    }
    return errors
  },
})(WorldCheckResolveFormUI)
